export default {
  SET_RESTING_STATE: 'welcome/SET_RESTING_STATE'
};
